import React, { useState } from 'react';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { TextField } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { StyledDiv } from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/Dialog/styles';
import DecisionDialog from 'components/DecisionDialog/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import { MISSION_POSTPONE_STATUS } from 'containers/data-structure';
import currentUserStorage from 'containers/services/security/current-user-storage';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';

export interface RejectionDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
  recap: any;
  claimId: number;
  claimNumber: string;
}

const RejectionDialog: React.FC<RejectionDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [reason, setReason] = useState('');
  const handleChangeReason = (event: any) => {
    setReason(event.target.value);
  };
  const successCallBack = () => {
    toast.success(
      translate(messages.toastRejectionPostPone, props, {
        type: get(props.recap, 'missionPostPone.type'),
      }),
    );
    props.onClose();
  };
  const handleValidate = () => {
    props.validateDialog(
      {
        status: MISSION_POSTPONE_STATUS.REJECTED,
        id: get(props.recap, 'missionPostPone.id'),
        decidedBy: currentUserStorage.get().username,
        type: get(props.recap, 'missionPostPone.type'),
        rejectReason: reason,
        claimId: props.claimId,
        expertCode: get(props.recap, 'missionPostPone.createdBy'),
        missionId: get(props.recap, 'missionPostPone.missionId'),
        claimNumber: props.claimNumber,
        isInboxesActive: featureService.hasFeature(
          FEATURES.ATTRIBUTION_INBOXES_MANAGER,
        ),
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
      },
      successCallBack,
    );
  };
  return (
    <DecisionDialog
      open={open}
      onClose={onClose}
      validateDialog={handleValidate}
      title={translate({ ...messages.decisionTitle }, props)}
      content={
        <StyledDiv>
          <TextField
            onChange={handleChangeReason}
            name={'reason'}
            value={reason}
            label={translate({ ...messages.reason }, props)}
            className="input"
            multiline
            fullWidth
          />
        </StyledDiv>
      }
      disabled={!reason}
      primaryButtonTitle={translate(messages.dialogValidationButton, props)}
      scondaryButtonTitle={translate(messages.dialogCancelButton, props)}
    />
  );
};

RejectionDialog.defaultProps = {
  open: false,
};

export default injectIntl(RejectionDialog);
